import React from 'react';

export const defaultSetIsFullScreen = () => {};

export const FullScreenContext = React.createContext<{
    enabled: boolean;
    fullScreenSectionId: string | null;
    isFullScreen: boolean;
    setIsFullScreen: (sectionId: string, fullScreen: boolean) => void;
    portalRef: React.RefObject<HTMLDivElement>;
}>({
    enabled: false,
    fullScreenSectionId: null,
    isFullScreen: false,
    setIsFullScreen: defaultSetIsFullScreen,
    portalRef: { current: null },
});
